import { render, staticRenderFns } from "./FunQueryLanguage.vue?vue&type=template&id=807fb58e&"
import script from "./FunQueryLanguage.vue?vue&type=script&lang=js&"
export * from "./FunQueryLanguage.vue?vue&type=script&lang=js&"
import style0 from "./FunQueryLanguage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports